import { PublicClientApplication } from '@azure/msal-browser';

/**
 * Shared "Infor Marketing Web Apps" app registration.
 *
 * The client and tenant IDs are not secrets — they are visible in every browser
 * login request — but they are kept here rather than scattered through the
 * components so there is a single place to change them. Overridable at build
 * time via REACT_APP_* environment variables.
 */
export const CLIENT_ID =
  process.env.REACT_APP_AZURE_CLIENT_ID || 'e0698434-6258-4cb9-9f9d-382613bcfa31';

export const TENANT_ID =
  process.env.REACT_APP_AZURE_TENANT_ID || '457d5685-0467-4d05-b23b-8f817adda47c';

export const AUTHORITY =
  process.env.REACT_APP_AZURE_AUTHORITY ||
  `https://login.microsoftonline.com/${TENANT_ID}`;

/**
 * Scope for our own API. This must be requested at login and re-acquired before
 * each protected call — an ID token is not a valid credential for the API.
 */
export const API_SCOPE =
  process.env.REACT_APP_API_SCOPE || `api://${CLIENT_ID}/access_as_user`;

/** Scopes requested at sign-in. The API scope is included so acquireTokenSilent succeeds later. */
export const LOGIN_SCOPES = ['openid', 'profile', API_SCOPE];

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: window.location.origin
  },
  // msal-browser v5 removed storeAuthStateInCookie / secureCookies from
  // CacheOptions; the guide's snippet targets v2. sessionStorage keeps tokens
  // scoped to the tab and clears them when it closes.
  cache: {
    cacheLocation: 'sessionStorage'
  }
});
